import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Label = (props) => {
    return (React.createElement(StyledLabel, { style: {
            ...props.style,
        }, className: props.className, theme: props.theme }, props.children));
};
export default Label;
const bgColors = {
    warning: THEME.WARNING,
    success: THEME.SUCCESS,
};
const colors = {
    warning: 'rgba(255,255,255,0.8)',
    success: 'rgba(255,255,255,0.8)',
};
const StyledLabel = styled.label `
  background-color: ${(props) => 
// @ts-ignore
bgColors[props.theme] || 'transparent'};
  color: ${(props) => 
// @ts-ignore
colors[props.theme] || 'inherit'};
  padding: 0.1em 0.5em;
  border-radius: 3px;
`;
//# sourceMappingURL=Label.js.map